/* eslint-disable no-restricted-globals */
import RUTJS from 'rutjs';

import Auth from '../api/Auth';

export const closeSesion = () => {
  Auth.signOut();
  localStorage.clear();
  location.href = '/';
};

export const isRUTValid = (rut) => {
  if (!rut) return true;
  if (rut.length < 8) return false;
  return (new RUTJS(rut)).isValid;
}

export const validateEmail = email => {
  if (!email) return true;
  return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(email);
}

export const validatePhone = phone => {
  if (!phone) return true;
  return (/^9\d.{7}$/i).test(phone);
}

export const getLabel = (event) => {
  let index = event.nativeEvent.target.selectedIndex;
  return event.nativeEvent.target[index].text;
}

export const copyToClipboard = (text) => {
  return navigator.clipboard.writeText(text);
}

export const rolesFormatter = (role) => {
  const roles = {
    'admin': 'Administrador',
    'admin-port': 'Administrador Portabilidad',
    'manager': 'Manager',
    'auditor': 'Auditor',
    'dec-executive': 'Ejecutivo DEC',
    'dec-executive-port': 'Ejecutivo Portabilidad',
    'sales-executive': 'Ejecutivo Ventas',
    'sales-executive-port': 'Ejecutivo Ventas Portabilidad',
    'first-contact-executive': 'Ejecutivo Primer Contacto',
    'sales-executive-sc': 'Ejecutivo Segundo Contacto',
    'purchase-advisor-sc': 'Asesor de Compra',
    'dec-executive-refinancing': 'Ejecutivo Refinanciamiento',
  };
  return roles[role] || role;
};

export const originTraducer = (origin) => {
  const origins = {
    'phone': 'Telefonía',
    'email': 'Correo electrónico',
    'web': 'Página web',
    'referred': 'Referido',
    'face': 'Presencial',
    'trinidad': 'Trinidad',
    'spider': 'Spider',
  };
  return origins[origin] || origin;
};

export const vehicleTypeFormatter = (vehicleType) => {
  return vehicleType === 'auto' ? '1' : '5'
}

export const tripleDotWithEnd = (name, maxLength) => name.length <= maxLength ? name : `${name.slice(0, maxLength - 1)}...${name.slice(-4)}`;